'use strict';

var joinStringArray = function (arr) {
    return (arr !== null && arr !== void 0 ? arr : []).join(', ');
};
var capitalize = function (val) {
    if (!val)
        return '';
    return "" + val.substring(0, 1).toUpperCase() + val.substring(1).toLowerCase();
};
var Strings = { joinStringArray: joinStringArray, capitalize: capitalize };

module.exports = Strings;
